import React, { useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import logo from "../assets/images/tiger2.png";
import shap from "../assets/images/shape1.png";
import "../assets/css/Login.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import axios from "axios";
import config from "../config";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

const Reset_password = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Validation
    if (!password || !confirmPass) {
      toast.warning("Both password fields are required.");
      return;
    }
    if (password.length < 6) {
      toast.warning("Password must be at least 6 characters");
      return;
    }
    if (password !== confirmPass) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.API_BASE_URL}/cforgotpass/reset-password/${token}`,
        { password }
      );

      toast.success(response.data.message);

      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Reset Password | Shaadi Material</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="useraccountDiv">
        <div className="fxt-shape">
          <div className="fxt-transformX-L-50 fxt-transition-delay-1">
            <img src={shap} alt="shape" />
          </div>
        </div>

        <Container>
          <Row className="mx-0 breadcrumb_part align-items-center">

            {/* LEFT SIDE */}
            <Col lg={8}>
              <div className="fxt-column-wrap justify-content-center">
                <div>
                  <div className="fxt-transformX-L-50 fxt-transition-delay-3">
                    <Link to="/" className="logo me-5">
                      <img src={logo} alt="Logo" style={{ height: "150px" }} />
                    </Link>
                  </div>

                  <div className="fxt-transformX-L-50 fxt-transition-delay-5">
                    <div className="fxt-middle-content">
                      <h1 className="fxt-main-title">
                        Reset Password <br /> Shaadi Material
                      </h1>

                      <div className="fxt-switcher-description1">
                        Remember your password?
                        <Link
                          to="/login"
                          className="fxt-switcher-text ms-2 fw-bold text-info"
                        >
                          Sign In
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            {/* RIGHT SIDE */}
            <Col lg={4}>
              <div className="prof_content user-dash">

                {/* New Password */}
                <div className="d-flex flex-column gap-2 mb-3">
                  <label>New Password</label>
                  <span className="p-input-icon-right">
                    <InputText
                      type={showPass ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter new password"
                    />
                    <i
                      className={showPass ? "pi pi-eye-slash" : "pi pi-eye"}
                      onClick={() => setShowPass(!showPass)}
                      style={{ cursor: "pointer", position: "absolute", right: "13px" }}
                    />
                  </span>
                </div>

                {/* Confirm Password */}
                <div className="d-flex flex-column gap-2 mb-3">
                  <label>Confirm Password</label>
                  <span className="p-input-icon-right">
                    <InputText
                      type={showConfirmPass ? "text" : "password"}
                      value={confirmPass}
                      onChange={(e) => setConfirmPass(e.target.value)}
                      placeholder="Confirm new password"
                    />
                    <i
                      className={showConfirmPass ? "pi pi-eye-slash" : "pi pi-eye"}
                      onClick={() => setShowConfirmPass(!showConfirmPass)}
                      style={{ cursor: "pointer", position: "absolute", right: "13px" }}
                    />
                  </span>
                </div>

                {/* Submit Button */}
                <Button
                  label={loading ? "Updating..." : "Update Password"}
                  className="py-2 w-100 custbuttonpink"
                  style={{ height: "50px" }}
                  onClick={handleSubmit}
                  disabled={loading}
                />

                <p className="text-secondary mt-4">
                  Return to?{" "}
                  <Link to="/login" className="text-info">
                    Log in
                  </Link>
                </p>

              </div>
            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
};

export default Reset_password;